import { useEffect } from 'react';
import { useUsers } from '../hooks/useUsers';
import { useOffersWithEnrollments } from '../hooks/useOffers';

/**
 * This component preloads data in the background when the app starts
 * It runs queries immediately and sets up background refresh intervals
 */
export const BackgroundPreloader: React.FC = () => {
  // These queries will start immediately and cache the results
  const usersQuery = useUsers();
  const offersQuery = useOffersWithEnrollments();

  useEffect(() => {
    // Log preload status for debugging
    console.log('📥 Background preloader active');
    console.log('📥 Users preload status:', usersQuery.status);
    console.log('📥 Offers preload status:', offersQuery.status);
  }, [usersQuery.status, offersQuery.status]);

  // This component doesn't render anything - it just loads data
  return null;
};
